import { render, staticRenderFns } from "./Reforco.vue?vue&type=template&id=ac6fc9bc&scoped=true"
import script from "./Reforco.vue?vue&type=script&lang=js"
export * from "./Reforco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6fc9bc",
  null
  
)

export default component.exports